import React, { FC, PropsWithChildren } from 'react'

import { UserData } from 'src/State/User/UserModel'
import { INSTALLER_PARTNER } from 'src/Configuration'
import { useFetchCompany, useFetchCompanyLocation } from 'src/Libs/service-dashboard/hooks'
import NdaPage from './NdaPage'
import { useTypedSelector } from 'src/State/RootReducer'
import { SuspenseContentFallback } from '@e3dc-react/shell/Elements/Suspense'

interface NdaCheckWrapperProps extends PropsWithChildren {
  user: UserData | null
  userLoading: boolean
}

/**
 * This component checks if nda was submitted for the installer/partner's company, if no shows the alternative screen where the user can submit the NDA
 * Missing NDA prevents the installer/partner from seeing or interacting with any other pages
 */
const NdaCheckWrapper: FC<NdaCheckWrapperProps> = ({ children, user, userLoading }) => {
  const userId = useTypedSelector(state => state.auth.userId)
  const isInstallerPartnerLevel = !userLoading && !!user && INSTALLER_PARTNER.includes(user.level)
  const [companyData, refetchCompanyData, isCompanyDataLoading] = useFetchCompany(user?.Firmen_ID)
  const [companyLocationData, , isCompanyLocationDataLoading] = useFetchCompanyLocation(user?.Firmen_ID)
  const isNdaNotSubmitted = !isCompanyDataLoading && !!companyData && !companyData?.ndaSubmit?.length
  const showNdaPage = isInstallerPartnerLevel && isNdaNotSubmitted

  if (isCompanyDataLoading || isCompanyLocationDataLoading) {
    return <SuspenseContentFallback />
  }

  if (showNdaPage) {
    return (
      <NdaPage
        user={{ ...user, ID: userId as number }}
        companyName={companyData?.name ?? ''}
        companyLocation={companyLocationData}
        refetchCompanyData={refetchCompanyData}
      />
    )
  }

  return <>{children}</>
}

export default NdaCheckWrapper
